// @flow
import { useIsMobile } from '../../hooks';

import styles from './SecondaryHeader.scss';

export type Props = {
  children: React.Node,
};

export function SecondaryHeader({ children }: Props): React.MixedElement {
  const isMobile = useIsMobile('(max-width: 40em)');

  if (isMobile) return <>{children}</>;

  return (
    <div className={styles.root}>
      <div className={styles.wrapper}>{children}</div>
    </div>
  );
}
